import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifications-sidebar',
  templateUrl: './notifications-sidebar.component.html',
  styleUrls: ['./notifications-sidebar.component.scss']
})
export class NotificationsSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
